import React, { useState } from 'react';
import api from '../api';
import { Link } from 'react-router-dom';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setDone('');
    if (password !== password2) {
      setError('Hai lần nhập mật khẩu không khớp.');
      return;
    }
    setBusy(true);
    try {
      const res = await api.post('/auth/register', { email, password });
      setDone(res.data?.message || 'Đăng ký thành công.');
      setEmail('');
      setPassword('');
      setPassword2('');
    } catch (err) {
      setError(err.response?.data?.error || 'Đăng ký thất bại');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 400, margin: '48px auto', padding: 24, border: '1px solid #e2e8f0', borderRadius: 12 }}>
      <h2 style={{ textAlign: 'center', marginTop: 0 }}>Đăng ký tài khoản</h2>
      <p style={{ fontSize: 14, color: '#64748b', textAlign: 'center' }}>
        Dùng <strong>email</strong> làm tên đăng nhập. Sau khi gửi form, quản trị sẽ duyệt trước khi bạn có thể đăng nhập.
      </p>
      <form onSubmit={handleSubmit}>
        <label style={{ display: 'block', marginBottom: 14 }}>
          <span style={{ fontSize: 14 }}>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            placeholder="ban@congty.com"
            style={{ display: 'block', width: '100%', marginTop: 6, padding: 10, boxSizing: 'border-box', borderRadius: 8, border: '1px solid #cbd5e1' }}
          />
        </label>
        <label style={{ display: 'block', marginBottom: 14 }}>
          <span style={{ fontSize: 14 }}>Mật khẩu (tối thiểu 6 ký tự)</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            autoComplete="new-password"
            style={{ display: 'block', width: '100%', marginTop: 6, padding: 10, boxSizing: 'border-box', borderRadius: 8, border: '1px solid #cbd5e1' }}
          />
        </label>
        <label style={{ display: 'block', marginBottom: 16 }}>
          <span style={{ fontSize: 14 }}>Nhập lại mật khẩu</span>
          <input
            type="password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
            minLength={6}
            autoComplete="new-password"
            style={{ display: 'block', width: '100%', marginTop: 6, padding: 10, boxSizing: 'border-box', borderRadius: 8, border: '1px solid #cbd5e1' }}
          />
        </label>
        {error && <p style={{ color: '#b91c1c', fontSize: 14 }}>{error}</p>}
        {done && <p style={{ color: '#15803d', fontSize: 14 }}>{done}</p>}
        <button
          type="submit"
          disabled={busy}
          style={{
            width: '100%',
            padding: 12,
            marginTop: 8,
            background: busy ? '#94a3b8' : '#059669',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontWeight: 600,
            cursor: busy ? 'wait' : 'pointer',
          }}
        >
          {busy ? 'Đang gửi…' : 'Gửi đăng ký'}
        </button>
      </form>
      <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14 }}>
        Đã có tài khoản? <Link to="/login">Đăng nhập</Link>
      </p>
    </div>
  );
};

export default RegisterPage;
